module.exports = __webpack_public_path__ + "img/marketing.b5556cf7.png";